"use strict";
module.exports = {
    INVITE_STATUS: {
        PENDING_SP_CREATION: 'pending_sp_creation',
        SP_PENDING_APPROVAL: 'sp_pending_approval',
        SP_CONFIRMED: 'sp_confirmed',
        SP_DECLINED: 'sp_declined',
        DELETED: 'deleted'
    }
};
